import React, { useState } from "react";
import { compose } from "redux";
import { withStyles } from "components/common";
import ReactJson from "react-json-view";

// const moment = require("moment");

const BankIdentityDataBox = ({ user }) => {
  const renderAccounts = account_data => (
    <ReactJson
      src={account_data}
      name="BankIdentityData"
      theme="summerfruit:inverted"
      iconStyle="circle"
      collapsed
      displayDataTypes={false}
      displayObjectSize={false}
      enableClipboard={false}
    />
  );
  const accounts = [];
  const { report } = user.asset_report || {};
  const { items } = report || {};
  if (report && items) {
    items.forEach(item => {
      (item.accounts || {}).forEach(acct => {
        const a = {
          name: acct.name,
          type: acct.type,
          subtype: acct.subtype,
          balances: acct.balances,
          owners: JSON.parse(acct.owners)
        };
        accounts.push(a);
      });
    });
  }

  return (
    <div className="mb-5">
      <h1 className="text-2xl font-title mb-2 font-light">
        Bank Identity Data
      </h1>
      <div>{renderAccounts(accounts)}</div>
    </div>
  );
};

export default compose(withStyles)(BankIdentityDataBox);
